module.exports = __webpack_public_path__ + "img/max-file-content-sync.1dd1a5f5.svg";